import {getLabelByField} from "../../utils/fields/programs";

const columns = [
	{
		id: 'Name',
		name: getLabelByField('Name'),
		sortable: true,
		selector: row => row.Name,
		cell: row => row.Name,
		width: '1fr'
	}, {
		id: 'Priority__c',
		name: 'Priority',
		sortable: true,
		selector: row => row.Priority__c,
		cell: row => row.Priority__c,
		width: '200px'
	}, {
		id: 'Status__c',
		name: 'Status',
		sortable: true,
		selector: row => row.Status__c,
		cell: row => row.Status__c,
		width: '200px'
	}, {
		id: 'Next_Step__c',
		name: 'Next Step',
		sortable: true,
		selector: row => row.Next_Step__c,
		cell: row => row.Next_Step__c,
		width: '200px'
	}, {
		id: 'Next_Step_Date__c',
		name: 'Next Step Date',
		sortable: true,
		selector: row => row.Next_Step_Date__c,
		cell: row => row.Next_Step_Date__c,
		width: '200px'
	}, {
		id: 'Expiration_Date__c',
		name: 'Expiration Date',
		sortable: true,
		selector: row => row.Expiration_Date__c,
		cell: row => row.Expiration_Date__c,
		width: '150px'
	}
];

export default columns;